import React from 'react';
import { styled } from '@mui/material/styles';
import { renderTypographyStyles } from 'mui/base/utils';
import { DS_breakpoints as coreBreakpoints } from 'mui/base/theme/DS_Tokens/core';
import { layoutHorizontalGapStyles } from 'mui/components/sharedStyles/layoutStyles';

const Markdown = React.lazy(() => import('mui/components/elements/DS_Markdown'));

export const StyledWrapper = styled('div')(
  ({ theme }) => `
    position: sticky;
    top: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
   
    ${theme.breakpoints.up('lg')} {
          margin: 0 auto;
          width: calc(100% - ${theme.DS_spacing(['md'])});
    }
    ${theme.breakpoints.up('xl')} { 
      max-width: ${coreBreakpoints['xl']}em;  

    }
    
    .fade {
      opacity: 1;
      display: block;
      transition: opacity 0.2s, visibility 0.2s;
    }
    
    .fade.dissapear {
      opacity: 0;
      display:none;
      transition: opacity 0.2s, visibility 0s 0.2s;
      height: 0;
      padding: 0;
      margin-bottom: 0;
      margin-top: 0;
    }
  `,
);

export const StyledMobileControls = styled('div')(
  ({ theme }) => `
    ${layoutHorizontalGapStyles({ theme })};

  `,
);

export const StyledDescription = styled(Markdown)(
  ({ theme }) => `
    ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
    color: ${theme.DS_palette.text.secondary};
    margin-top: -${theme.DS_spacing(['xs'])};
  `,
);

export const LinkWrapper = styled('div')(
  ({ theme }) => `
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: -${theme.DS_spacing(['xs'])};
    margin-bottom: ${theme.DS_spacing(['xxs'])};
    color: ${theme.DS_palette.buttons.enabled};
   ${theme.breakpoints.up('lg')} {
        margin-top: -${theme.DS_spacing(['xxs'])};
        margin-bottom: ${theme.DS_spacing(['sm'])};
       
   }
  `,
);

export const Loader = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoaderWrapper = styled('div')(
  ({ theme, isMap }) => `
    min-height: 40px;
    height: ${isMap ? '100%' : 'auto'};
    background-color: ${isMap ? `${theme.DS_palette.background.lightgrey}` : 'white'};
  `,
);

export const StyledTabsWrapper = styled('div')(
  ({ theme }) => `
    .MuiTabs-fixed {
      ${layoutHorizontalGapStyles({ theme })};
    }
    .MuiTabs-flexContainer {
      margin: 0 !important;
      padding-top: ${theme.DS_spacing(['xs'])};
    }
    button.booking-locations-view {
      color: ${theme.DS_palette.buttons.enabled};
      background-color: ${theme.DS_palette.background.light};
      text-transform: inherit;
      white-space: break-spaces;
      min-height: unset;
      height: 38px;
      ${renderTypographyStyles(theme.typography.DS_copySmallBold)};
      border-radius: 10px;
      width: 48%;
      padding: 14px 0;
      line-height: 14px;
      
      &.Mui-selected {
        background-color: ${theme.DS_palette.buttons.enabled};
        color: ${theme.DS_palette.primary.white};
      }
    }
    
    ${theme.breakpoints.up('md')} {
      button.booking-locations-view {
        ${renderTypographyStyles(theme.typography.DS_copyMediumBold)};
        font-size: 1rem;
        width: 49%;
        max-width: unset;
        padding: ${theme.DS_spacing(['md'])};
      }
    }
    ${theme.breakpoints.up('lg')} {
      [data-test="box-tabs"] {
        min-width: 624px;
        max-width: 624px;
      }
      button.booking-locations-view {
        line-height: 24px;
      }
    }
  `,
);

export const StyledBannerWrapper = styled('div')(
  ({ theme }) => `
    padding: 0;
    margin-top: ${theme.DS_spacing(['xxs'])};
    ${theme.breakpoints.up('lg')} {
      margin-top: unset;
      margin-bottom: ${theme.DS_spacing(['md'])};
    }
  `,
);

export const StyledLocationsWrapper = styled('div')(
  ({ theme }) => `
    margin-top: ${theme.DS_spacing(['xxs'])};

  `,
);

const SharedMapWrapperHeight = () => `
  height: 600px;
  min-height: 600px;
`;

export const StyledMapWrapper = styled('div')(
  ({ theme }) => `
    ${SharedMapWrapperHeight()};
    position: relative;
    z-index: 1;
    margin-top: ${theme.DS_spacing(['md'])};
  `,
);

export const StyledMapLoaderWrapper = styled('div')(
  ({ theme }) => `
    width: 100%;
    z-index: 1;
    ${SharedMapWrapperHeight()};
    position: absolute;
      
    &::before {
      content: "";
      background-color: ${theme.DS_palette.background.lightgrey};
      opacity: 0.5;
      ${SharedMapWrapperHeight()};
      width: 100%;
      position: absolute;
      top: 0;
    }
    
    > div {
      ${SharedMapWrapperHeight()};
    }
    
    ${theme.breakpoints.up('lg')} {
      > div {
        > div {
          position: absolute;
          right: 27%;
        } 
      }
    }
 `,
);

export const StyledAsteriskFootnote = styled('div')(
  ({ theme }) => `

    padding: ${theme.DS_spacing(['xxs'])};
    p {
      color: ${theme.DS_palette.text.secondary};
    }

  `,
);
